import api from './api';

// 주문 내역 조회
export const getOrderHistory = async (params = {}) => {
  const { data } = await api.get('/orders/', { params });
  return data;
};

// 주문 상세 조회
export const getOrderDetail = async (orderId) => {
  const { data } = await api.get(`/orders/${orderId}/`);
  return data;
};

// 주문 취소
export const cancelOrder = async (orderId) => {
  const { data } = await api.post(`/orders/${orderId}/cancel/`);
  return data;
};

// 포인트 내역 조회
export const getPointHistory = async (params = {}) => {
  const { data } = await api.get('/orders/points/', { params });
  return data;
};

// 현재 포인트 잔액
export const getPointBalance = async () => {
  const { data } = await api.get('/orders/points/balance/');
  return data;
};

export default {
  getOrderHistory,
  getOrderDetail,
  cancelOrder,
  getPointHistory,
  getPointBalance,
};